<template src='./graficaGestion.html'></template>
<script>
import VueApexCharts from "vue-apexcharts";
import ComponenteSelect from "../../ComponenteSelect/ComponenteSelect";
import formularioOverlay from "../../formularioOverlay/formularioOverlay";
import {
  gestionConsulta,
  actualizarOrden,
  consultarOrdenesEstadoPorServicio,
  actualizarOrdenResumenLlamada
} from "../../../apiService/request/gestionSeguimientos";
import {
  crearEncuentroSeguimiento,
  crearFormulario,
  consultarEstructuraFormulario,
  consultarTipoEncuentroSeguimiento
} from "../../../apiService/request/CrudSeguimiento";
import { serverBus } from "../../../main";
import Icono from "../../Icono/Icono";
import mixinGraficas from "../../../js/mixins/mixinGraficas";
import mixinScroll from "../../../js/mixins/mixinScroll";
import FiltrosGestion from "../FiltrosGestion/FiltrosGestion";
export default {
  data: function() {
    return {
      tituloPadre: "",
      search: "",
      ocultarFiltrosEstados: true,
      selected: [],
      page: 1,
      pageCount: 0,
      itemsPerPage: 3,
      graficaKey: 0,
      opciones: [
        {
          chart: {
            type: "bar",
            // height: 350,
            stacked: true,
            toolbar: {
              show: false
            },
            events: {
              dataPointSelection: (event, chartContext, config) => {
                this.showTable(config.dataPointIndex);
              },
              click: (event, chartContext, config) => {
                if (
                  event.target.className === "apexcharts-legend-text" ||
                  event.target.className === "apexcharts-legend-series" ||
                  event.target.className === "apexcharts-legend-marker"
                ) {
                  this.showTable(Number(event.target.getAttribute("rel")) - 1);
                }
              }
            }
          },
          legend: {
            // show: true,
            position: "bottom",
            horizontalAlign: "left",
            offsetX: 40,
            height: 200
          },
          states: {
            active: {
              allowMultipleDataPointsSelection: false,
              filter: {
                type: "darken",
                value: 0.3
              }
            }
          },
          // colors: ['#3A5FBA', '#3D88C4', '#3F9AAE','#3DC4B9','#8DDFF2','#579FF2','#67C2EF','#7CD5CE'],
          // colors: ["#3A5FBA", "#3D88C4", "#3F9AAE"],
        colors: [ "#579FF2","#946EEB","#90A4AE","#F0706C","#B7C53B","#F38D89","#D493B0","#45B8DD","#BA567C","#3ABA8B","#55669F","#EFE18B","#ED8432",
          "#F0AE7B"],
          dataLabels: {
            // enabled: true,
            textAnchor: "center",
            style: {
              colors: ["#fff"],
              fontSize: 15
            },
            offsetX: 0
          },
          grid: {
            row: {
              colors: ["#F4F5F8"]
            }
          },
          xaxis: {
            categories: [],
            labels: {
              style: {
                colors: ["#646a6f"],
                fontSize: "16px",
                fontFamily: "Nunito, sans-serif"
              },
              min: 20
            }
          },
          fill: {
            // colors: ["#3D88C4"],

            type: "gradient",
            gradient: {
              shade: "light"
              // type: "vertical",
              // shadeIntensity: 0.45,
              // gradientToColors: undefined,
              // inverseColors: true,
              // opacityFrom: 0.75,
              // opacityTo: 0.85
            }
          },

          plotOptions: {
            bar: {
              // horizontal: false,
              // barHeight: '100%',
              distributed: true,
              horizontal: true,
              //  distributed: true,/*Activa que se pongan varios colores*/
              // endingShape: "rounded",
              // columnWidth: "100%",
              dataLabels: {
                // position: "bottom"
              }
            },
            colors: ["#3D88C4"]
          },
          yaxis: {
            labels: {
              show: false,
              style: {
                fontSize: 20 /**El texto de la izquierda de la grafica */,
                fontSize: "16px",
                fontFamily: "Nunito, sans-serif"
              }
            }
          }
        }
      ],
      series: [
        {
          data: []
        }
      ],
      seguimiento: [
        {
          nombre_lista: "Tipo gestión",
          key_lista: "tipo_gestion",
          opciones_lista: [
            {
              nombre: "Gestión llamadas",
              key: "llamada",
              valor: "Gestión llamadas"
            },
            {
              nombre: "Gestión seguimientos",
              key: "seguimiento",
              valor: "Gestión seguimientos"
            },
            {
              nombre: "Gestión ayudas diagnósticas",
              key: "ayuda_diagnostica",
              valor: "Gestión ayudas diagnósticas"
            }
          ]
        }
      ],
      banderaGrafica: false,
      banderaTabla: false,
      headers: [],
      desserts: [],
      sort_by: [],
      sort_desc: [],
      respuesta: {},
      overlay: false,
      banderaSubirArchivo: false,
      paciente: {},
      verComponente: "",
      docId: "",
      item: "",
      itemSeleccionado: "",
      verEncuentro:
        "M31.3,8.6h-4V8.1c0-0.6-0.4-1-1-1H25C24.6,5.9,23.4,5,22,5s-2.6,0.9-3,2.1h-1.3c-0.6,0-1,0.4-1,1v0.4h-4c-1.3,0-2.4,1.1-2.4,2.4v23.6c0,1.3,1.1,2.4,2.4,2.4h18.6c1.3,0,2.4-1.1,2.4-2.4V11C33.7,9.7,32.6,8.6,31.3,8.6z M28.9,13.4v18.7H15.1V13.4H28.9z M18.7,9.1h1.1c0.6,0,1-0.4,1-1C20.9,7.5,21.4,7,22,7s1.1,0.5,1.1,1.1c0,0.6,0.4,1,1,1h1.1v2.3h-6.6V9.1zM31.7,34.6c0,0.2-0.2,0.4-0.4,0.4H12.7c-0.2,0-0.4-0.2-0.4-0.4V11c0-0.2,0.2-0.4,0.4-0.4h4v0.9h-2.6c-0.6,0-1,0.4-1,1v20.7c0,0.6,0.4,1,1,1h15.7c0.6,0,1-0.4,1-1V12.4c0-0.6-0.4-1-1-1h-2.6v-0.9h4c0.2,0,0.4,0.2,0.4,0.4V34.6z M17,25.1h2.3v2.3c0,0.6,0.4,1,1,1h3.3c0.6,0,1-0.4,1-1v-2.3H27c0.6,0,1-0.4,1-1v-3.3c0-0.6-0.4-1-1-1h-2.3v-2.3c0-0.6-0.4-1-1-1h-3.3c-0.6,0-1,0.4-1,1v2.3H17c-0.6,0-1,0.4-1,1v3.3C16,24.6,16.4,25.1,17,25.1z M18,21.8h2.3c0.6,0,1-0.4,1-1v-2.3h1.3v2.3c0,0.6,0.4,1,1,1H26v1.3h-2.3c-0.6,0-1,0.4-1,1v2.3h-1.3v-2.3c0-0.6-0.4-1-1-1H18V21.8z M22,0C9.9,0,0,9.9,0,22s9.9,22,22,22s22-9.9,22-22S34.1,0,22,0z M22,42C11,42,2,33,2,22S11,2,22,2s20,9,20,20S33,42,22,42z",
      iconoAgenda:
        "M37,8H5C3.3,8,2,6.7,2,5s1.3-3,3-3h26c0.6,0,1-0.4,1-1s-0.4-1-1-1H5C2.2,0,0,2.2,0,5v34c0,2.8,2.2,5,5,5h28c2.8,0,5-2.2,5-5V9C38,8.4,37.6,8,37,8z M30,10v8.6l-3.3-3.3C26.5,15.1,26.3,15,26,15s-0.5,0.1-0.7,0.3L22,18.6V10H30z M2,39V9c0.8,0.6,1.9,1,3,1h2v32H5C3.3,42,2,40.7,2,39z M33,42H9V10h11v11c0,0.4,0.2,0.8,0.6,0.9c0.4,0.2,0.8,0.1,1.1-0.2l4.3-4.3l4.3,4.3c0.2,0.2,0.4,0.3,0.7,0.3c0.1,0,0.3,0,0.4-0.1c0.4-0.2,0.6-0.5,0.6-0.9V10h4v29C36,40.7,34.7,42,33,42z M32,29c0,0.6-0.4,1-1,1H14c-0.6,0-1-0.4-1-1s0.4-1,1-1h17C31.6,28,32,28.4,32,29z M32,33c0,0.6-0.4,1-1,1H14c-0.6,0-1-0.4-1-1s0.4-1,1-1h17C31.6,32,32,32.4,32,33z M26,37c0,0.6-0.4,1-1,1H14c-0.6,0-1-0.4-1-1s0.4-1,1-1h11C25.6,36,26,36.4,26,37z",
      iconoNoContesto:
        "M44,21.1v9.4c0,0.3-0.1,0.6-0.4,0.8c-0.2,0.1-0.4,0.2-0.6,0.2c-0.1,0-0.2,0-0.2,0l-10-2.5c-0.5-0.1-0.9-0.7-0.7-1.2c0.1-0.5,0.7-0.9,1.2-0.7l8.8,2.2v-7.5c-6.1-3.4-13-5.2-20-5.2c-0.9,0-1.7,0-2.4,0.1c-0.5,0-1-0.4-1.1-0.9c0-0.6,0.4-1,0.9-1.1c0.7,0,1.6-0.1,2.5-0.1c7.5,0,15,2,21.5,5.8C43.8,20.4,44,20.8,44,21.1z M30,26c0.6,0,1-0.4,1-1v-2.7c0-0.5-0.3-0.9-0.8-1c-1.4-0.3-2.9-0.5-4.4-0.6c-0.5-0.1-1,0.4-1.1,0.9s0.4,1,0.9,1.1c1.2,0.1,2.3,0.3,3.4,0.4V25C29,25.6,29.4,26,30,26z M43.7,42.3c0.4,0.4,0.4,1,0,1.4C43.5,43.9,43.3,44,43,44s-0.5-0.1-0.7-0.3L21.1,22.5c-2.1,0-4.1,0.2-6.1,0.6v4.4c0,0.5-0.3,0.9-0.8,1l-13,3c-0.1,0-0.1,0-0.2,0c-0.2,0-0.4-0.1-0.6-0.2C0.1,31.1,0,30.8,0,30.5v-9.4c0-0.4,0.2-0.7,0.5-0.9c4.2-2.4,8.7-4.1,13.4-5L0.3,1.7c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0L43.7,42.3z M19.2,20.6L15.6,17c-4.8,0.8-9.4,2.3-13.6,4.7v7.5l11-2.5v-4.4c0-0.5,0.3-0.9,0.8-1C15.6,21,17.4,20.7,19.2,20.6z"
    };
  },
  mounted() {
    serverBus.$on("jsonSeleccion", jsonSeleccion => {
      this.banderaGrafica = false;
      this.seleccionSeguimientos(jsonSeleccion);
    });
    serverBus.$on("formularioActualizado", response => {
      this.overlay = false;
      this.actualizarOrdenLlamada(this.item, this.docId);
    });
  },
  beforeUpdate() {},
  beforeDestroy() {
    serverBus.$off("jsonSeleccion");
    serverBus.$off("formularioActualizado");
  },
  mounted() {
    this.estadosSeleccionados = ["autorizada"];
  },
  mixins: [mixinGraficas,mixinScroll],
  props: ["valorSeleccionadoDialogo"],
  watch: {
    valorSeleccionadoDialogo: function(newVal, oldVal) {
      // watch it
      if (newVal == "Aceptar") {
        this.$store.dispatch(
          "setMensajeChatBox",
          `${this.itemSeleccionado.documento} ${this.itemSeleccionado.procedimiento} ${this.tipo_gestion}`
        );
      }
    }
  },
  components: {
    apexcharts: VueApexCharts,
    ComponenteSelect,
    formularioOverlay,
    Icono,
    FiltrosGestion
  },
  methods: {
    forceRerender() {
      this.graficaKey += 1;
    },
    cerrarOverlay(valor) {
      this.overlay = valor;
    },
    verOverlayHC(item) {
      this.verComponente = "verHistoriaClinica";
      this.overlay = true;
      this.$store.dispatch("setCedulaPaciente", item.documento);
    },
    // async consultarDatosGrafica(tipo_gestion, fechaInicial, fechaFinal, estados) {
    //   try {
    //     this.banderaGrafica = false;
    //     this.banderaTabla = false;
    //     this.$store.dispatch("setCargando", true);
    //     this.respuesta = await consultarOrdenesEstadoPorServicio(tipo_gestion,fechaInicial, fechaFinal, estados);
    //     this.datosConsultaPadre = {tipo_gestion,fechaInicial,fechaFinal,estados};
    //     this.respuesta.data.data.headers.push({ text: "Gestión",value: "gestion", sortable: false});
    //     this.getGraphicData(this.respuesta, 0);
    //   } finally {
    //     this.banderaGrafica = true;
    //     this.$store.dispatch("setCargando", false);
    //   }
    // },
    async consultarDatosGrafica(
      tipo_gestion,
      fechaInicial,
      fechaFinal,
      estados
    ) {
      // this.parametrosPadre = [event, chartContext, config];
      try {
        this.banderaTabla = false;
        this.tipo_gestion = tipo_gestion;
        this.respuesta = await consultarOrdenesEstadoPorServicio(
          tipo_gestion,
          fechaInicial,
          fechaFinal,
          estados
        );
        this.getGraphicData(this.respuesta, 0);
      } finally {
        this.banderaGrafica = true;
        // this.tituloPadre = this.respuesta.data.data.ejeX[config.dataPointIndex];
        // this.tituloHijo = "";
        this.forceRerender();
      }
      this.respuesta.data.data.headers.push({
        text: "Gestión",
        value: "gestion",
        sortable: false
      });
    },
    // async consultarDatosGrafica(tipo_gestion){
    //   this.banderaTabla = false;
    //   this.banderaGrafica = false;
    //   try{
    //     this.respuesta = await gestionConsulta(tipo_gestion);
    //     this.tipo_gestion = tipo_gestion;
    //     this.options.xaxis.categories = this.respuesta.data.data.ejeX;
    //     this.series[0].data = this.respuesta.data.data.series;
    //     const maximo = Math.max.apply(null, this.respuesta.data.data.series);
    //     let max = maximo + 1;
    //     this.options.yaxis.max = !max ? 0 : max;
    //     if(this.respuesta.data.data.series.length > 0){
    //       this.banderaGrafica = true;
    //     }
    //   }catch(error){
    //   }
    // },
    showTable(index) {
      try {
        this.banderaTabla = true;
        this.desserts = this.respuesta.data.data.usuarios[index];
        this.headers = this.respuesta.data.data.headers;
        this.sort_by = this.respuesta.data.data.sort_by;
        this.tituloPadre = this.respuesta.data.data.ejeX[index];
        // this.headers[this.headers.length] = { text: 'Gestión', value: 'gestion', sortable:false }
      }
      finally{
        setTimeout(() => {
          this.autoScroll(
            "scrolldown",
            "item2Comprimido",
            0
          );
        }, 100);
      }
    },
    async successFunction(item) {
      // this.$store.dispatch('setMensajeChatBox', item.documento+' '+item.procedimiento)
      this.tipo_gestion == "llamada" && (await this.actualizarFactura(item));
      this.itemSeleccionado = item;
      const dialogoModal = {
        dialogo: true,
        mensaje: "¿Esta seguro de cambiar el estado de esta orden?",
        opciones: ["Aceptar", "Cancelar"],
        status: 200
      };
      this.$store.dispatch("cambiarEstadoModal", true);
      this.$store.dispatch("cambiarMensajeModal", dialogoModal);
      // this.$store.dispatch('setMensajeChatBox', `${item.documento} ${item.procedimiento} ${this.tipo_gestion}`);
    },
    async actualizarFactura(item) {
      const jsonEnvio = {};
      jsonEnvio["documento"] = item.documento;
      jsonEnvio["procedimiento"] = item.cups;
      jsonEnvio["estado"] = "autorizada";
      jsonEnvio["newData"] = [
        {
          nombre: "za01724f9a",
          valor: "factura"
        }
      ];
      try {
        const response = await actualizarOrden(jsonEnvio);
        this.consultarDatosGrafica(this.tipo_gestion);
      } catch (error) {}
    },
    async failedFunction(item) {
      const response = await crearEncuentroSeguimiento(
        "seguimiento_no_exitoso",
        item.documento,
        this.$store.state.provider_email
      );
      this.crearCuestionarioSeguimiento(item, "resumen_de_llamada", response);
      this.item = item;
    },
    async crearCuestionarioSeguimiento(item, nombre_formulario, response) {
      try {
        const respuesta = await crearFormulario(
          "formularios",
          this.$store.state.provider_email,
          nombre_formulario,
          parseInt(item.documento),
          this.$store.state.provider_email,
          response.data.data.docId
        );
        this.docId = respuesta.data.data.docId;
        this.$store.dispatch("setIdFormulario", respuesta.data.data.docId);
        this.consultarEsquemaCuestionarioSeguimiento(respuesta.data.data.docId);
      } catch (err) {}
    },
    async consultarEsquemaCuestionarioSeguimiento(formulario_id) {
      try {
        const respuesta = await consultarEstructuraFormulario(formulario_id);
        // this.preguntasEncuestas=respuesta.data.data.variables
        this.$store.dispatch(
          "setVariablesFormularios",
          respuesta.data.data.variables
        );
        this.$store.dispatch("setNombreFormulario", respuesta.data.data.key);
        this.$store.dispatch("setColeccion", respuesta.data.data.coleccion);
        this.overlay = true;
      } catch (err) {}
    },
    async actualizarOrdenLlamada(item, docId) {
      const jsonEnvio = {
        docIdOrden: item.docId,
        docIdLlamada: docId
      };
      try {
        const response = await actualizarOrdenResumenLlamada(jsonEnvio);
      } catch (error) {}
    },
    async verEncuentroSeguimiento(item) {
      if (item.origen == "seguimientos") {
        this.verComponente = "seguimientos";
      } else if (item.origen == "encuentros") {
        this.verComponente = "encuentros";
      }
      await this.consultarTipoEncuentroSeguimientoPaciente(
        item.origen,
        item.id
      );
      this.$store.dispatch("setId", item.id);
      this.$store.dispatch("setCedulaPaciente", item.documento);
      this.paciente = item;
      this.overlay = true;
      serverBus.$emit("verEncuentroGestion", this.overlay);
    },
    async consultarTipoEncuentroSeguimientoPaciente(origen, id) {
      try {
        const respuesta = await consultarTipoEncuentroSeguimiento(origen, id);
        if (origen == "encuentros") {
          this.$store.dispatch(
            "setConsultarEncuentro",
            respuesta.data.data.key
          );
        } else if (origen == "seguimientos") {
          this.$store.dispatch("setNombreEvento", respuesta.data.data.key);
        }
      } finally {
      }
    }
  }
};
</script>
<style lang="scss" src='../graficaGestion.scss'></style>



// WEBPACK FOOTER //
// src/components/Gestion/graficaGestion/graficaGestion.vue